module.exports = {"pathContext":{"relativePath":"GDK>src/pages/landing.js"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = 313
// module chunks = 142629428675168